module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-reservation-controller"
  }, [_c('statistics-card4', [_c('div', {
    staticClass: "field-reporting-type",
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_c('div', {
    staticClass: "field-type-name"
  }, [_vm._v(_vm._s(_vm.item.type.name))]), _c('div', {
    staticClass: "field-type-description"
  }, [_vm._v(_vm._s(_vm.item.type.description))])]), _c('div', {
    staticClass: "field-reporting-status",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    staticClass: "field-reporting-location",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Location")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.location))])]), _c('div', {
    staticClass: "field-reporting-timestamp",
    attrs: {
      "slot": "n4"
    },
    slot: "n4"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v("Created " + _vm._s(_vm.$dateFormat(_vm.item.created, "DD-MM-YYYY HH:mm:ss")))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Updated " + _vm._s(_vm.$dateFormat(_vm.item.updated, "DD-MM-YYYY HH:mm:ss")))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-6 small-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.driver
    }
  })], 1), (_vm.item.vehicle) ? _c('vehicle', {
    attrs: {
      "type": 'compact-card',
      "item": _vm.item.vehicle
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "columns large-6 small-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.item.description))]), _c('hr'), (_vm.item.damage_position_raw) ? _c('vehicle-damage', {
    attrs: {
      "items": _vm.item.damage_position_raw,
      "vehicleType": _vm.item.vehicle.category.vehicle_type.name,
      "vehicleDamagePicture": _vm.item.vehicle.category.damage_picture_external
    }
  }) : _vm._e(), _c('h2', [_vm._v("Attachments")]), _vm._l((_vm.item.attachments), function(attachment) {
    return _c('backoffice-attachment', {
      attrs: {
        "item": attachment
      }
    })
  })], 2)])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52a2bfb9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Reporting.vue
// module id = 2348
// module chunks = 1